function prepareRequestProperties(isTemplate, overviewId) {
  const baseUrl = `overviews${isTemplate ? "/templates" : ""}`
  const type = isTemplate ? "template" : "overview"

  const getFetchKey = () => {
    const overviewFetchKey = overviewId ? `/${baseUrl}/${overviewId}` : null
    return isTemplate && overviewFetchKey === null
      ? `/${baseUrl}`
      : overviewFetchKey
  }

  return {
    overviewKey: getFetchKey(),
    type,
    overviewId: overviewId,
  }
}

function prepareViewableRequestProperties(viewableType, lookupId, parentKeys) {
  const urlType = viewableType === "group" ? "view_groups" : "views"
  const baseUrl = lookupId ? `/${urlType}/${lookupId}/overview` : null
  const type = "viewable"

  return {
    overviewKey: baseUrl,
    type,
    overviewId: lookupId,
    parentKeys,
  }
}

export const UseOverviewUtils = {
  prepareRequestProperties,
  prepareViewableRequestProperties,
}
